import { Box, Flex, Anchor } from "@mantine/core";
import { IconBuilding, IconWorld, IconId , IconShieldCheck } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import type { ReactNode } from "react";

type SignupFlowLayoutProps = {
  children: ReactNode;
};

export function SignupFlowLayout({ children }: SignupFlowLayoutProps) {
  return (
    <Box style={{ minHeight: "100vh", display: "flex" }}>
      <Box
        style={{
            flex: "0 0 40%",
          position: "relative",
          overflow: "hidden",
          background: `
            linear-gradient(90deg, rgba(100, 200, 255, 0.15) 2px, transparent 2px),
            linear-gradient(rgba(100, 200, 255, 0.15) 2px, transparent 2px),
            linear-gradient(90deg, rgba(100, 200, 255, 0.08) 1px, transparent 1px),
            linear-gradient(rgba(100, 200, 255, 0.08) 1px, transparent 1px),
            linear-gradient(135deg, #0a2e5c 0%, #0f3a66 50%, #1a4d7a 100%)
          `,
          backgroundSize: "200px 200px, 200px 200px, 40px 40px, 40px 40px, 100% 100%",
        }}
        visibleFrom="md"
      >
        <Box
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: "0px 56px 200px",
          }}
        >
     <div>
      <Flex
      align="center"
      gap={8}
      className="inline-flex px-4 py-3 text-white text-sm select-none"
      style={{ 
        display: "inline-flex",
        borderRadius: "9999px",
        background: "rgba(255, 255, 255, .08)",
        border: "1px solid rgba(255, 255, 255, .2)"
      }}
    >
      <IconShieldCheck size={16} className="text-[#fbf707]" />
      Verification-First Global Expansion
    </Flex>
     </div>
          <p style={{ fontSize: 40, fontWeight: 700, color: "#ffffff", marginBottom: 20, marginTop: 0 }}>
            Start Your <span className="text-[oklch(87.9%_0.169_91.605)]">Global collaboration</span> Journey
          </p>

          <p style={{ fontSize: 20, color: "rgba(255,255,255,0.8)", marginBottom: 48, marginTop: 0 }}>
            Register your verified business profile and connect with <span className="text-[oklch(87.9%_0.169_91.605)]" >trusted partners</span> across the globe.
          </p>

          <Flex direction="column" gap={20}>
            {[
              { icon: <IconBuilding size={18} />, text: "Register your company with verified credentials" },
              { icon: <IconWorld size={18} />, text: "Access a network spanning 100+ countries" },
              { icon: <IconId size={18} />, text: "Secure document verification process" },
            ].map(({ icon, text }) => (
              <Flex key={text} align="center" gap={14}>
                <Box
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 8,
                    background: "rgba(251, 247, 7, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "oklch(87.9% 0.169 91.605)",
                    flexShrink: 0,
                  }}
                >
                  {icon}
                </Box>
                <span style={{ fontSize: 18, color: "rgba(255,255,255,0.8)" }}>{text}</span>
              </Flex>
            ))}
          </Flex>
        </Box>
      </Box>

      <Box
        px={{ base: "md", sm: "xl" }}
        py={{ base: "lg", sm: "48px" }}
        style={{ flex: 1, background: "var(--mantine-color-white)", overflowY: "auto" }}
      >
        <Flex direction="column" align="center" mb="xl">
          <img src="/gtLogo.svg" alt="GTsetu" style={{ height: 120, width: "auto" }} />
        </Flex>

        {children}

        <Flex justify="center" mt="md">
          <Anchor component={Link} to="/login" size="sm" c="slate.6">
            ← Back to Login
          </Anchor>
        </Flex>
      </Box>
    </Box>
  );
}
